"use strict";

var _interopRequireDefault = require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _axios = _interopRequireDefault(require("axios"));
var _elementUi = require("element-ui");
var _store = _interopRequireDefault(require("../store"));
var _auth = require("@/utils/auth");
// 创建axios实例
var service = _axios.default.create({
  baseURL: process.env.BASE_API,
  // api 的 base_url
  timeout: 50000 // 请求超时时间
});

// request拦截器
service.interceptors.request.use(function (config) {
  if (_store.default.getters.token) {
    config.headers['X-Token'] = _store.default.getters.token || (0, _auth.getToken)(); // 优先 Vuex，避免跨站 iframe cookie 被阻止
  }
  return config;
}, function (error) {
  // Do something with request error
  console.log(error); // for debug
  Promise.reject(error);
});

// response 拦截器
service.interceptors.response.use(function (response) {
  //code为非20000是抛错 可结合自己业务进行修改
  var res = response.data;
  if (res.code && res.code !== 200) {
    _elementUi.Message.closeAll();
    (0, _elementUi.Message)({
      message: res.msg,
      type: 'error',
      duration: 5 * 1000
    });
    if (typeof res == "string") {
      res = JSON.parse(res);
    }
    // 用户模块
    if (res.code === 401) {
      _elementUi.Message.closeAll();
      _elementUi.MessageBox.confirm(res.msg, '确定登出', {
        confirmButtonText: '重新登录',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        _store.default.dispatch('FedLogOut').then(function () {
          location.reload(); // 为了重新实例化vue-router对象 避免bug
        });
      });
    } else {
      return Promise.reject('error');
    }
  } else {
    return response.data;
  }
}, function (error) {
  console.log('err' + error); // for debug
  _elementUi.Message.closeAll();
  (0, _elementUi.Message)({
    message: error.message,
    type: 'error',
    duration: 5 * 1000
  });
  return Promise.reject(error);
});
var _default = exports.default = service;